import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';



// Index
export { default as Home } from './page/Home';
export { default as Category } from './page/CategoryView';
export { default as Book } from './page/Book';
export { default as Search } from './page/Search';
export { default as Library } from './page/Library';
export { default as SignIn } from './page/SignIn';

serviceWorker.unregister();



ReactDOM.render(
    <BrowserRouter >
        <App  />
    </BrowserRouter>,
	document.getElementById('root')
);

serviceWorker.unregister();
